import EnumPeriodForAnalytic from '../../../../Common/Models/Enums/EnumPeriodForAnalytic';

export default class EndpointTimeStatisticRequest  {
	EndpointId: number = 0;
	FromDate: Date = null;
	ToDate: Date = null;
	Period: EnumPeriodForAnalytic = null;
	constructor(obj?: Partial<EndpointTimeStatisticRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
